import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  HostBinding
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '@services/app.service';
import { Router } from "@angular/router";
import { LoginDetails } from "@/models/login/LoginDetails";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  /* @HostBinding('class') class = 'login-box';*/
  public isAuthLoading = false;
  public isGoogleLoading = false;
  public isFacebookLoading = false;
  showPassword = false;
  loginResponse: LoginDetails | undefined;
  userType: string = "";

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.renderer.addClass(
      document.querySelector('app-root'),
      'login-page'
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl("", [Validators.required, Validators.nullValidator,
    Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10),
    Validators.maxLength(10)]),
    password: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator])
  });

  public loginErrors = {
    username: '',
    password: ''
  }


  // Login Validation is any Mandatory fields is empty
  loginValidation() {
    this.loginErrors.username = "";
    this.loginErrors.password = "";
    let hasError = false;
    if (this.loginForm.get('username')?.invalid) {
      if (this.loginForm.get('username')?.errors?.required) {
        this.loginErrors.username = "Phone Number is required";
      }
      if (this.loginForm.get('username')?.errors?.pattern) {
        this.loginErrors.username = "Please, Enter 10 digit registered Phone Number.";
      }
      hasError = true;
    }
    if (this.loginForm.get("password")?.invalid) {
      if (this.loginForm.get("password")?.hasError("required")) {
        this.loginErrors.password = "Please enter correct password";
      } else if (this.loginForm.get("password")?.hasError("minlength")) {
        this.loginErrors.password = "Password must be at least 10 characters long";
      } else if (this.loginForm.get("password")?.hasError("maxlength")) {
        this.loginErrors.password = "Password cannot exceed 10 characters";
      }
      hasError = true;
    }
    if (!hasError) {
      this.loginDetails();
    }
  }

  onSubmit() {
    this.loginValidation()
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  loginDetails() {
    const loginData = { ...this.loginForm.value };
    if (loginData.username && !loginData.username.startsWith("91")) {
      loginData.username = "91" + loginData.username;
    }
    this.spinner.show();
    console.log(`User details:`, loginData);
    this.appService.loginUserData(loginData)
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          console.log("User Login successfully", response);
          this.loginResponse = response;
          localStorage.setItem('authToken', response.authHeader);
          localStorage.setItem('userType', response.login.userType);
          this.authService.setSession(response);
          // SET APP USER (THIS WAS MISSING)
          this.appService.setUser({
            username: response.login.username,
            userType: response.login.userType
          });

          if (response.login.userType === 'ADMIN' || response.login.userType === 'SUPER_ADMIN') {
            this.toastr.success('Admin login successful');

            // DO NOT double navigate
            this.router.navigate(['/main/invoice']);
            return;
          }

          // Block non-admin
          this.toastr.error('Access Denied');
          this.appService.clearUser();
          localStorage.clear();
          this.router.navigate(['/login']);
        },
        error: (error) => {
          this.spinner.hide();
          console.error("Error Login user", error);
          this.toastr.error(error.error.message || "Something went wrong, Please try again....");
        },
      });
  }

  /* async loginByAuth() {
     if (this.loginForm.valid) {
       this.isAuthLoading = true;
       await this.appService.loginWithEmail(
         this.loginForm.value.email,
         this.loginForm.value.password
       );
 
       this.isAuthLoading = false;
     } else {
       this.toastr.error('Form is not valid!');
     }
   }
 
   async loginByGoogle() {
     this.isGoogleLoading = true;
     await this.appService.signInByGoogle();
     this.isGoogleLoading = false;
   }*/

  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'login-page'
    );
  }
}
